/**
 * ProcessingModal - Non-dismissable processing state with spinner
 *
 * Shows a loading spinner with status message while async operations
 * are in progress. Displays error state with retry option on failure.
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import ModalShell from './ModalShell';
import './ProcessingModal.css';

interface ProcessingModalProps {
  status: string;
  error?: string;
  onRetry?: () => void;
}

const ProcessingModal: React.FC<ProcessingModalProps> = ({
  status,
  error,
  onRetry,
}) => {
  const { t } = useTranslation(['creator', 'common']);

  return (
    <ModalShell
      title={t('creator:workflow.resourceModal.processingTitle')}
      showClose={false}
      showFooter={false}
    >
      <div className="processing-modal-content">
        {/* Spinner (hidden when there is an error) */}
        {!error && <div className="processing-spinner" />}

        {/* Status message */}
        <p className="processing-status">{status}</p>

        {/* Error display */}
        {error && (
          <>
            <div className="processing-error">{error}</div>
            {onRetry && (
              <button
                type="button"
                className="processing-retry-btn"
                onClick={onRetry}
              >
                {t('common:retry')}
              </button>
            )}
          </>
        )}
      </div>
    </ModalShell>
  );
};

export default ProcessingModal;
